//* Importar Arquivos do firebase (app, autenticação e banco de dados)
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

//* Configuração de ligação entre o projeto e o firebase
const config = {
  apiKey: "AIzaSyDlmOY8kpdQEVJkY3rJwjN-A74VD5h4Tis",
  authDomain: "resultam-docs.firebaseapp.com",
  databaseURL: "https://resultam-docs.firebaseio.com",
  projectId: "resultam-docs",
  storageBucket: "resultam-docs.appspot.com",
  messagingSenderId: "335507483365"
}
const app = firebase.initializeApp(config)

//* Exportar o firebase para uso em outros arquivos
export const auth = app.auth()
export const db = app.database()
export const googleProvider = new firebase.auth.GoogleAuthProvider()